import { mapState, mapGetters } from 'vuex'

export default {
  name: 'StatsFilter',
  props: {
    targetStats: {
      type: String,
      default: 'impressions',
    },
  },
  methods: {
    triggerSetTargetStats(val) {
      this.$emit('update:target-stats', val)
    },
  },
  computed: {
    ...mapState({
      getStatsCompleted: (state) => state.campaign.analytics.stats.getStatsCompleted,
      targetCampaignUUID: (state) => state.campaign.targetCampaignUUID,
    }),
    ...mapGetters('campaign/analytics/stats', [
      'allCampaignImpressionsByUUID',
      'allCampaignConversionsByUUID',
      'allCampaignLeadsByUUID',
    ]),
    totalImpressions() {
      if (!this.targetCampaignUUID || !this.getStatsCompleted) {
        return 233
      }

      return this.allCampaignImpressionsByUUID(this.targetCampaignUUID)
    },
    totalConversions() {
      if (!this.targetCampaignUUID || !this.getStatsCompleted) {
        return 100
      }

      return this.allCampaignConversionsByUUID(this.targetCampaignUUID)
    },
    totalCTR() {
      const totalPercentage = (this.totalConversions / this.totalImpressions) *
        100

      if (isNaN(totalPercentage)) {
        return 0
      }

      return parseFloat(totalPercentage.toFixed(2))
    },
    totalEmailsCollected() {
      if (!this.targetCampaignUUID || !this.getStatsCompleted) {
        return 42
      }

      return this.allCampaignLeadsByUUID(this.targetCampaignUUID)
    },
  },
}
